<template>
  <div>
    <div class="row mb-3">
      <!-- TODO: previous select -->
      <slot name="prev"></slot>
      <!-- TODO: association select -->
      <select-component
        v-if="filterOfAssociation"
        :dataOptions="associations"
        :requireClass="isRequiredAssociations ? `required-associations` : ``"
        :rowClass="`${!isDrawerContent ? classAssociation : `col-12`} pt-3`"
        @onChange="handleChangeSelected"
        :labelSelect="$t('comp.fil.filters.text1')"
        modelName="association_ids"
      />
      <!-- TODO: businesses select -->
      <select-component
        v-if="filterOfBusinesses"
        :rowClass="`${!isDrawerContent ? classBusinesses : `col-12`} pt-3`"
        :labelSelect="`${
          isRequiredBusinesses
            ? $t('common_words.companies') + ': *'
            : $t('common_words.companies') + ':'
        }`"
        :dataOptions="getBusinessByAssociation()"
        :requireClass="isRequiredBusinesses ? `required-businesses` : ``"
        :initialSelection="model.businesses_ids"
        @onChange="handleChangeSelected"
        modelName="businesses_ids"
      />
      <!-- TODO: zones select -->
      <select-component
        v-if="filterOfZones"
        :rowClass="`${!isDrawerContent ? classZones : `col-12`} pt-3`"
        :labelSelect="`${$t('common_words.zones')}: `"
        :dataOptions="this.concatAll(zones)"
        :requireClass="isRequiredZones ? `required-zones` : ``"
        @onChange="handleChangeSelected"
        modelName="zone_ids"
      />
      <!-- TODO: sub zones select -->
      <select-component
        v-if="filterOfZones && filterOfSubZones"
        :rowClass="`${!isDrawerContent ? classSubZones : `col-12`} pt-3`"
        :labelSelect="`${$t('common_words.sub_zones')}: `"
        :dataOptions="availableSubzones"
        :requireClass="isRequiredSubZones ? `required-subzones` : ``"
        :initialSelection="model.subzone_ids"
        @onChange="handleChangeSelected"
        modelName="subzone_ids"
      />
      <!-- TODO: crop types select -->
      <select-component
        v-if="filterOfCropTypes"
        :rowClass="`${!isDrawerContent ? classCropTypes : `col-12`} pt-3`"
        :labelSelect="`${$t('common_words.types_of_crops')}: `"
        :dataOptions="croptypes"
        :requireClass="isRequiredCropTypes ? `required-croptypes` : ``"
        :initialSelection="model.croptypes_ids"
        @onChange="handleChangeSelected"
        modelName="croptypes_ids"
      />
      <!-- TODO: crops select -->
      <select-component
        v-if="filterOfCrops"
        :rowClass="`${!isDrawerContent ? classCrops : `col-12`} pt-3`"
        :labelSelect="`${$t('common_words.crops')}: `"
        :dataOptions="getCropsByBusinesses()"
        :requireClass="isRequiredCrops ? `required-crops` : ``"
        :initialSelection="model.crops_ids"
        @onChange="handleChangeSelected"
        modelName="crops_ids"
      />
      <!-- TODO: calendars select -->
      <select-component
        v-if="isShowCalendar"
        :rowClass="`${!isDrawerContent ? classCalendar : `col-12`} pt-3`"
        :labelSelect="`${$t('common_words.calendar')}: `"
        :dataOptions="calendars"
        :requireClass="`required-calendar`"
        :initialSelection="model.calendar_sel"
        @onChange="handleChangeSelected"
        modelName="calendar_sel"
      />
      <!-- TODO: farms select -->
      <select-component
        v-if="filterOfFarms"
        :rowClass="`${!isDrawerContent ? classFarms : `col-12`} pt-3`"
        :labelSelect="`${
          isMultipleFarms ? $t('common_words.farms2') : $t('common_words.farm')
        }: ${isRequiredFarms ? '*' : ''}`"
        :dataOptions="availableFarms"
        :requireClass="isRequiredFarms ? `required-farm` : ``"
        :initialSelection="isMultipleFarms ? model.farm_ids : model.farm_id"
        :isMultiple="isMultipleFarms"
        @onChange="handleChangeSelected"
        modelName="farm_ids"
      />
      <slot name="after-farm"></slot>
      <!-- TODO: lots select -->
      <select-component
        v-if="filterOfLots"
        :rowClass="`${!isDrawerContent ? classLots : `col-12`} pt-3`"
        :labelSelect="`${
          isMultipleLots
            ? $t('common_words.allotments')
            : $t('common_words.allotment')
        }: ${isRequiredLots ? '*' : ''}`"
        :dataOptions="getLotbyFarm()"
        :requireClass="isRequiredLots ? `required-lot` : ``"
        :initialSelection="isMultipleLots ? model.lot_ids : model.lot_id"
        :isMultiple="isMultipleLots"
        @onChange="handleChangeSelected"
        modelName="lot_ids"
      />
      <slot name="after-lot"></slot>
      <!-- TODO: ribbons select -->
      <select-component
        v-if="filterOfRibbons"
        :rowClass="`${!isDrawerContent ? classRibbons : `col-12`} pt-3`"
        :labelSelect="`${$t('production.ribbon')}: `"
        :dataOptions="getRibbons()"
        :requireClass="isRequiredRibbons ? `required-ribbons` : ``"
        :initialSelection="model.ribbons_id"
        @onChange="handleChangeSelected"
        modelName="ribbons_id"
        valueLabel="color_name"
      />
      <!-- TODO: users select -->
      <select-component
        v-if="filterOfUsers"
        :rowClass="`${!isDrawerContent ? classUsers : `col-12`} pt-3`"
        :labelSelect="`${$t('common_words.users')}: ${
          isRequiredUsers ? '*' : ''
        }`"
        :dataOptions="concatAll(users)"
        :requireClass="isRequiredUsers ? `required-users` : ``"
        :initialSelection="model.users_ids"
        @onChange="handleChangeSelected"
        modelName="users_ids"
      />
      <!-- TODO: workers select -->
      <select-component
        v-if="filterOfWorkers"
        :rowClass="`${!isDrawerContent ? classWorkers : `col-12`} pt-3`"
        :labelSelect="`${$t('labor.workers')}: ${isRequiredWorkers ? '*' : ''}`"
        :dataOptions="concatAll(workers)"
        :requireClass="isRequiredWorkers ? `required-workers` : ``"
        :initialSelection="model.workers_ids"
        @onChange="handleChangeSelected"
        modelName="workers_ids"
      />
    </div>
    <div :class="`row ${model.comparate ? `` : `mb-4`}`">
      <div class="col-12" v-if="isShowDivision">
        <hr class="mb-2" />
      </div>
      <br v-if="onlyWeekTime" />
      <br v-if="onlyWeekTime" />
      <!-- TODO: time select -->
      <select-component
        v-if="filterOfTimeRange && !onlyWeekTime"
        :rowClass="`${
          !isDrawerContent ? `col-12 col-sm-12 col-md-3 col-lg-2` : `col-12`
        }`"
        :labelSelect="$t('comp.fil.filters.text2')"
        :isMultiple="false"
        modelName="bySel"
        :dataOptions="Object.values(getOptionsIntervals)"
        :requireClass="`required-time`"
        :modelInitial="model.bySel"
        @onChange="handleChangeSelected"
        valueLabel="label"
        valueOption="model"
      />
      <!-- TODO: calendar picker -->
      <div
        v-bind:class="`${
          !isDrawerContent ? `col-12 col-md-9 col-lg-5` : `col-12 pt-3`
        }`"
        v-if="model.bySel && model.bySel != 'Semana' && model.bySel != 'Año'"
      >
        <label>{{ calendarLabel[0] }}</label>
        <br />
        <el-date-picker
          v-if="renderComponent"
          v-model="rangeDate"
          :class="`shadow-sm required-year ${
            showCalendarComparate ? `` : `mb-4`
          }`"
          v-bind:type="typedatepicket"
          :picker-options="pickerOptions"
          range-separator="-"
          :placeholder="`${$t('common_words.select2')}...`"
          :start-placeholder="$t('common_words.initial_date')"
          :end-placeholder="$t('common_words.final_date')"
          :change="getPreviousYearWeek"
        >
        </el-date-picker>
        <label v-if="showCalendarComparate" class="mt-3"
          >{{ calendarLabel[1] }}
        </label>
        <br v-if="showCalendarComparate" />
        <el-date-picker
          v-if="renderComponent && showCalendarComparate"
          v-model="rangeDateComparate"
          class="shadow-sm required-year-comparate mb-4"
          v-bind:type="typedatepicket"
          :picker-options="pickerOptionsComparate"
          range-separator="-"
          :placeholder="`${$t('common_words.select2')}...`"
          :start-placeholder="$t('common_words.initial_date')"
          :end-placeholder="$t('common_words.final_date')"
        >
        </el-date-picker>
      </div>
      <div
        v-if="model.bySel == 'Semana' || model.bySel == 'Año'"
        v-bind:class="`${
          !isDrawerContent
            ? `col-12 ${
                model.bySel === 'Año'
                  ? `col-md-5 col-lg-4`
                  : `col-md-9 col-lg-${
                      verifyIsset(model.year_sel_init) &&
                      verifyIsset(model.year_sel_end)
                        ? `7`
                        : verifyIsset(model.year_sel_init) &&
                          !verifyIsset(model.year_sel_end)
                        ? `5`
                        : `4`
                    }`
              }`
            : `col-12 pt-3`
        }`"
      >
        <div class="row">
          <!-- TODO: first years select -->
          <select-component
            v-if="model.bySel == 'Semana' || model.bySel == 'Año'"
            :dataOptions="[...years]"
            :isMultiple="false"
            :labelSelect="onlyWeekTime ? $t('common_words.initial_week') : ''"
            :requireClass="`required-year`"
            :rowClass="`col-6 ${
              !isDrawerContent
                ? `${
                    model.bySel == 'Semana'
                      ? `col-sm-${
                          verifyIsset(model.year_sel_init) &&
                          verifyIsset(model.year_sel_end)
                            ? `3`
                            : verifyIsset(model.year_sel_init) &&
                              !verifyIsset(model.year_sel_end)
                            ? `4`
                            : `6`
                        }`
                      : ``
                  }`
                : ``
            }`"
            :rowStyle="`${!isDrawerContent ? `padding-right: 0;` : ``} ${
              onlyWeekTime ? `` : `padding-top: 33px`
            }`"
            :initialSelection="model.year_sel_init"
            @onChange="handleChangeSelected"
            modelName="year_sel_init"
            placeholder="2023..."
          />
          <!-- TODO: first week select -->
          <select-component
            v-if="model.bySel == 'Semana' && model.year_sel_init"
            :dataOptions="
              years.find((element) => element.id == model.year_sel_init)
                .years[1]
            "
            :isMultiple="false"
            :labelSelect="`${onlyWeekTime ? `&nbsp;&nbsp;` : ``}`"
            :requireClass="`required-week`"
            :rowClass="`col-6 ${
              !isDrawerContent
                ? `${
                    model.bySel == 'Semana'
                      ? `col-sm-${
                          verifyIsset(model.year_sel_init) &&
                          verifyIsset(model.year_sel_end)
                            ? `3`
                            : verifyIsset(model.year_sel_init) &&
                              !verifyIsset(model.year_sel_end)
                            ? `4`
                            : `6`
                        }`
                      : ``
                  }`
                : ``
            }`"
            :rowStyle="`${onlyWeekTime ? `` : `padding-top: 33px`}`"
            :initialSelection="model.week_sel_init"
            @onChange="handleChangeSelected"
            modelName="week_sel_init"
            placeholder="06..."
            valueLabel="option"
            valueOption="option"
          />
          <!-- TODO: end years select -->
          <select-component
            v-if="model.bySel == 'Semana' || model.bySel == 'Año'"
            :dataOptions="[...years]"
            :isMultiple="false"
            :labelSelect="onlyWeekTime ? $t('common_words.final_week') : ''"
            :requireClass="`required-year`"
            :rowClass="`col-6 ${
              !isDrawerContent
                ? `${
                    model.bySel === 'Semana'
                      ? `col-sm-${
                          verifyIsset(model.year_sel_init) &&
                          verifyIsset(model.year_sel_end)
                            ? `3`
                            : verifyIsset(model.year_sel_init) &&
                              !verifyIsset(model.year_sel_end)
                            ? `4`
                            : `6`
                        }`
                      : ``
                  }`
                : ``
            }`"
            :rowStyle="`${!isDrawerContent ? `padding-right: 0;` : ``} ${
              onlyWeekTime ? `` : `padding-top: 33px`
            }`"
            :initialSelection="model.year_sel_end"
            @onChange="handleChangeSelected"
            modelName="year_sel_end"
            placeholder="2023..."
          />
          <!-- TODO: end week select -->
          <select-component
            v-if="model.bySel == 'Semana' && model.year_sel_end"
            :dataOptions="
              years.find((element) => element.id == model.year_sel_end).years[1]
            "
            :isMultiple="false"
            :labelSelect="`${onlyWeekTime ? `&nbsp;&nbsp;` : ``}`"
            :requireClass="`required-week`"
            :rowClass="`${!isDrawerContent ? `col-6 col-sm-3` : `col-6`}`"
            :rowStyle="`${onlyWeekTime ? `` : `padding-top: 33px`}`"
            :initialSelection="model.week_sel_end"
            @onChange="handleChangeSelected"
            modelName="week_sel_end"
            placeholder="52..."
            valueLabel="option"
            valueOption="option"
          />
        </div>
      </div>
      <slot name="after"></slot>
      <button-filter
        v-if="!model.comparate || (model.comparate && isCalendar)"
        :classData="!isDrawerContent ? `col-12 col-md-4 col-lg-2` : `col-12`"
        :showComparate="showCheckboxComparate"
        :initialValue="model.comparate"
        @handledOnChecked="handledOnChecked"
        @validate="validate"
      />
      <slot name="after-filter"></slot>
    </div>
    <div class="row" v-if="model.comparate">
      <div
        :class="`${
          !isDrawerContent ? `col-12 col-sm-12 col-md-3 col-lg-2` : `col-12`
        }`"
      ></div>
      <div
        v-if="model.bySel == 'Semana' || model.bySel == 'Año'"
        v-bind:class="`${
          !isDrawerContent
            ? `col-12 ${
                model.bySel === 'Año'
                  ? `col-md-5 col-lg-4`
                  : `col-md-9 col-lg-${
                      verifyIsset(model.year_sel_init) &&
                      verifyIsset(model.year_sel_end)
                        ? `7`
                        : verifyIsset(model.year_sel_init) &&
                          !verifyIsset(model.year_sel_end)
                        ? `5`
                        : `4`
                    }`
              }`
            : `col-12 pt-3`
        }`"
      >
        <div class="row mb-2">
          <label class="col-12 mb-0">{{ $t('comp.fil.filters.text3') }}</label>
        </div>
        <div class="row">
          <!-- TODO: first years select -->
          <select-component
            v-if="model.bySel == 'Semana' || model.bySel == 'Año'"
            :dataOptions="compYears"
            :isMultiple="false"
            :labelSelect="onlyWeekTime ? $t('common_words.initial_week') : ''"
            :requireClass="`required-comp-year`"
            :rowClass="`col-6 ${
              !isDrawerContent
                ? `${
                    model.bySel == 'Semana'
                      ? `col-sm-${
                          verifyIsset(model.year_sel_init) &&
                          verifyIsset(model.year_sel_end)
                            ? `3`
                            : verifyIsset(model.year_sel_init) &&
                              !verifyIsset(model.year_sel_end)
                            ? `4`
                            : `6`
                        }`
                      : ``
                  }`
                : ``
            }`"
            :rowStyle="`${!isDrawerContent ? `padding-right: 0;` : ``}`"
            :initialSelection="model.comp_year_sel_init"
            @onChange="handleChangeSelected"
            modelName="comp_year_sel_init"
            placeholder="2022..."
          />
          <!-- TODO: first week select -->
          <select-component
            v-if="model.bySel == 'Semana' && model.comp_year_sel_init"
            :dataOptions="compWeekInit"
            :isMultiple="false"
            :labelSelect="`${onlyWeekTime ? `&nbsp;&nbsp;` : ``}`"
            :requireClass="`required-comp-week`"
            :rowClass="`col-6 ${
              !isDrawerContent
                ? `${
                    model.bySel == 'Semana'
                      ? `col-sm-${
                          verifyIsset(model.year_sel_init) &&
                          verifyIsset(model.year_sel_end)
                            ? `3`
                            : verifyIsset(model.year_sel_init) &&
                              !verifyIsset(model.year_sel_end)
                            ? `4`
                            : `6`
                        }`
                      : ``
                  }`
                : ``
            }`"
            :initialSelection="model.comp_week_sel_init"
            @onChange="handleChangeSelected"
            modelName="comp_week_sel_init"
            placeholder="06..."
          />
          <!-- TODO: end years select -->
          <select-component
            v-if="model.bySel == 'Semana' || model.bySel == 'Año'"
            :dataOptions="compYears"
            :isMultiple="false"
            :labelSelect="onlyWeekTime ? $t('common_words.final_week') : ''"
            :requireClass="`required-comp-year`"
            :rowClass="`col-6 ${
              !isDrawerContent
                ? `${
                    model.bySel === 'Semana'
                      ? `col-sm-${
                          verifyIsset(model.year_sel_init) &&
                          verifyIsset(model.year_sel_end)
                            ? `3`
                            : verifyIsset(model.year_sel_init) &&
                              !verifyIsset(model.year_sel_end)
                            ? `4`
                            : `6`
                        }`
                      : ``
                  }`
                : ``
            }`"
            :rowStyle="`${!isDrawerContent ? `padding-right: 0;` : ``}`"
            :initialSelection="model.comp_year_sel_end"
            @onChange="handleChangeSelected"
            modelName="comp_year_sel_end"
            placeholder="2022..."
          />
          <!-- TODO: end week select -->
          <select-component
            v-if="model.bySel == 'Semana' && model.comp_year_sel_end"
            :dataOptions="compWeekEnd"
            :isMultiple="false"
            :labelSelect="`${onlyWeekTime ? `&nbsp;&nbsp;` : ``}`"
            :requireClass="`required-comp-week`"
            :rowClass="`${!isDrawerContent ? `col-6 col-sm-3` : `col-6`}`"
            :initialSelection="model.comp_week_sel_end"
            @onChange="handleChangeSelected"
            modelName="comp_week_sel_end"
            placeholder="52..."
          />
        </div>
      </div>
      <button-filter
        v-if="model.comparate && !isCalendar"
        :classData="!isDrawerContent ? `col-12 col-md-4 col-lg-2` : `col-12`"
        :showComparate="showCheckboxComparate"
        :initialValue="model.comparate"
        @handledOnChecked="handledOnChecked"
        @validate="validate"
      />
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import ButtonFilter from './ButtonFilter.vue';
import MixinCalendar from 'src/util/mixinCalendar';
import MixinCreated from './mixin-created-method';
import MixinDatePicker from 'src/util/mixinDatePicker';
import MixinLoadData from './mixin-load-data';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinProps from './mixin-props';
import MixinValidate from './mixin-validate';
import moment from 'moment';
import Select from '../Selects/Select';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    [Select.name]: Select,
    [ButtonFilter.name]: ButtonFilter,
  },

  name: 'filter-component',
  mixins: [
    MixinCalendar,
    MixinCreated,
    MixinDatePicker,
    MixinLoadData,
    MixinMasters,
    MixinPermissions,
    MixinProps,
    MixinValidate,
  ],

  data() {
    return {
      interval: 'Día',
      model: {
        association_ids: [],
        businesses_ids: [],
        crops_ids: [],
        croptypes_ids: [],
        bySel: 'Día',
        farm_ids: [],
        farm_id: null,
        lot_ids: [],
        lot_id: null,
        ribbons_id: [],
        subzone_ids: [],
        users_ids: [],
        workers_ids: [],
        week_sel_end: null,
        week_sel_init: null,
        year_sel_end: null,
        year_sel_init: null,
        calendar_sel: null,
        zone_ids: [],
        comparate: false,
        comp_year_sel_init: null,
        comp_week_sel_init: null,
        comp_year_sel_end: null,
        comp_week_sel_end: null,
      },
      typedatepicket: 'daterange',
      rangeDateComparate: [],
    };
  },

  computed: {
    compYears() {
      const yearWeek =
        Number(this.model.year_sel_init) * 100 +
        Number(this.model.week_sel_init);

      return this.years.map((element) => ({
        ...element,
        disabled: yearWeek <= Number(element.id) * 100 + 1,
      }));
    },

    compWeekInit() {
      try {
        const yearSelected = [...this.years].find((year) => {
          return Number(year.id) === Number(this.model.comp_year_sel_init);
        });

        return [...yearSelected.years[1]].map((week) => {
          const yearWeek =
            Number(this.model.year_sel_init) * 100 +
            Number(this.model.week_sel_init);
          const weekToValidate =
            Number(this.model.comp_year_sel_init) * 100 + Number(week);

          return { name: week, id: week, disabled: weekToValidate >= yearWeek };
        });
      } catch (error) {
        return [];
      }
    },

    compWeekEnd() {
      try {
        const yearSelected = [...this.years].find((year) => {
          return Number(year.id) === Number(this.model.comp_year_sel_end);
        });

        return [...yearSelected.years[1]].map((week) => {
          const yearWeek =
            Number(this.model.year_sel_init) * 100 +
            Number(this.model.week_sel_init);
          const weekToValidate =
            Number(this.model.comp_year_sel_end) * 100 + Number(week);

          return { name: week, id: week, disabled: weekToValidate >= yearWeek };
        });
      } catch (error) {
        return [];
      }
    },

    availableSubzones() {
      // Si no hay zonas seleccionadas, devolvemos vacío
      if (!isset(this.model.zone_ids)) return [];

      // 1) Filtramos sólo las zonas seleccionadas
      const selectedZones = this.zones.filter((z) =>
        this.model.zone_ids.includes(z.id)
      );

      // 2) Para cada zona, construimos sus subzonas formateadas
      const formatted = selectedZones.flatMap((zone) => {
        return (zone.subzones || []).map((sub) => ({
          id: sub.id,
          name: `${i18n.t('common_words.zone')}: ${zone.name} – ${i18n.t(
            'common_words.subzone'
          )}: ${sub.name}`,
        }));
      });

      return this.concatAll(formatted);
    },

    availableFarms() {
      const businessSel = this.model.businesses_ids || [];
      const zonesSel = this.model.zone_ids || [];
      const subzonesSel = this.model.subzone_ids || [];
      const cropTypesSel = this.model.croptypes_ids || [];
      const cropsSel = this.model.crops_ids || [];

      const data = this.farms.filter((farm) => {
        // Presencia de datos
        const farmHasBusiness =
          Array.isArray(farm.businesses) && farm.businesses.length > 0;
        const farmHasZone = !!farm.zone;
        const farmHasSubzone = !!farm.subzone;
        const farmHasCropType = farm.crop_type_id != null;
        const farmHasCrop = farm.crop_id != null;

        // Cálculos básicos de match
        const matchBusiness =
          farmHasBusiness &&
          (businessSel.length
            ? farm.businesses.some((b) => businessSel.includes(b.id))
            : true);

        const matchZone =
          farmHasZone &&
          (zonesSel.length ? zonesSel.includes(farm.zone.id) : true);

        const matchSubzone =
          farmHasSubzone &&
          (subzonesSel.length ? subzonesSel.includes(farm.subzone.id) : true);

        const matchCropTypes =
          farmHasCropType &&
          (cropTypesSel.length
            ? cropTypesSel.includes(farm.crop_type_id)
            : true);

        const matchCrops =
          farmHasCrop &&
          (cropsSel.length ? cropsSel.includes(farm.crop_id) : true);

        // 1) Business (si está habilitado y hay selección)
        if (this.filterOfBusinesses && businessSel.length) {
          if (!matchBusiness) return false;
        }

        // 2) Zona & Subzona (si están habilitados)
        if (this.filterOfZones || this.filterOfSubZones) {
          if (
            this.filterOfZones &&
            this.filterOfSubZones &&
            zonesSel.length &&
            subzonesSel.length
          ) {
            // ambos filtros activos → AND
            if (!(matchZone && matchSubzone)) return false;
          } else {
            // uno solo activo → OR
            if (this.filterOfZones && zonesSel.length && !matchZone)
              return false;
            if (this.filterOfSubZones && subzonesSel.length && !matchSubzone)
              return false;
          }
        }

        // 3) Crop Types (si está habilitado y hay selección)
        if (this.filterOfCropTypes && cropTypesSel.length) {
          if (!matchCropTypes) return false;
        }

        // 4) Crops (si está habilitado y hay selección)
        if (this.filterOfCrops && cropsSel.length) {
          if (!matchCrops) return false;
        }

        // Si pasó todos los checks, la finca se incluye
        return true;
      });

      return this.isMultipleFarms ? this.concatAll(data) : data;
    },

    calendars() {
      if (this.model.farm_ids) {
        let calendars = [];
        this.farms.forEach((element) => {
          this.model.farm_ids.forEach((elFarm) => {
            if (element.id == elFarm) calendars = element.calendars;
          });
        });

        return calendars;
      } else {
        return [];
      }
    },

    getOptionsIntervals() {
      if (this.showHour) {
        return { ...this.optionsInterval };
      }

      const response = Object.values({ ...this.optionsInterval }).filter(
        (option) => option.value !== 'datetimerange'
      );

      return response;
    },

    calendarLabel() {
      if (this.model.comparate && this.showComparate) {
        return [
          i18n.t('common_words.calendar'),
          i18n.t('comp.fil.filters.text4'),
        ];
      }

      return [i18n.t('common_words.calendar')];
    },

    isCalendar() {
      return this.model.bySel !== 'Semana' && this.model.bySel !== 'Año';
    },

    isShowDivision() {
      return (
        this.filterOfAssociation ||
        this.filterOfBusinesses ||
        this.filterOfCrops ||
        this.filterOfCropTypes ||
        this.filterOfZones ||
        this.filterOfSubZones ||
        this.filterOfFarms ||
        this.filterOfLots ||
        this.filterOfRibbons ||
        this.showDivision
      );
    },

    showCalendarComparate() {
      return (
        (this.showComparate === 1 &&
          this.model.comparate &&
          this.model.bySel !== 'Hora') ||
        (this.model.comparate && this.showComparate === 2)
      );
    },

    showCheckboxComparate() {
      return (
        (this.showComparate === 1 && this.model.bySel !== 'Hora') ||
        this.showComparate === 2
      );
    },

    getPreviousYearWeek() {
      if (this.model.comparate) {
        switch (this.model.bySel) {
          case 'Semana':
          case 'Año':
            const indexToSet = [
              { index: 'year_sel_init', type: 'year' },
              { index: 'week_sel_init', type: 'week' },
              { index: 'year_sel_end', type: 'year' },
              { index: 'week_sel_end', type: 'week' },
            ];

            indexToSet.forEach((item) => {
              const data = this.model[item.index];
              if (isset(data)) {
                const value = parseInt(data, 10);
                let previous = item.type === 'week' ? null : value - 1;

                setTimeout(() => {
                  this.$set(this.model, `comp_${item.index}`, previous);
                }, 10);
              } else this.$set(this.model, `comp_${item.index}`, null);
            });
            break;

          case 'Día':
          case 'Hora':
            const diff = moment(this.rangeDate[1]).diff(
              moment(this.rangeDate[0]),
              'days'
            );

            this.rangeDateComparate = [
              moment(this.rangeDate[0]).subtract(diff + 1, 'days'),
              moment(this.rangeDate[0]).subtract(1, 'days'),
            ];

            break;

          case 'Mes':
            const diffMonth = moment(this.rangeDate[1]).diff(
              moment(this.rangeDate[0]),
              'months'
            );

            this.rangeDateComparate = [
              moment(this.rangeDate[0]).subtract(
                diffMonth + (Number(diffMonth) === 0 ? 2 : 1),
                'months'
              ),
              moment(this.rangeDate[0]).subtract(1, 'months'),
            ];

            break;

          default:
            break;
        }
      } else {
        this.$set(this.model, 'comp_week_sel_end', null);
        this.$set(this.model, 'comp_week_sel_init', null);
        this.$set(this.model, 'comp_year_sel_end', null);
        this.$set(this.model, 'comp_year_sel_init', null);
      }
    },

    optionsInterval() {
      return {
        0: {
          label: i18n.t('common_words.hour'),
          value: 'datetimerange',
          model: 'Hora',
        },
        1: {
          label: i18n.t('common_words.day'),
          value: 'daterange',
          model: 'Día',
        },
        2: {
          label: i18n.t('common_words.week'),
          value: 'week',
          model: 'Semana',
        },
        3: {
          label: i18n.t('common_words.month'),
          value: 'monthrange',
          model: 'Mes',
        },
        4: {
          label: i18n.t('common_words.year'),
          value: 'year',
          model: 'Año',
        },
      };
    },

    pickerOptionsComparate() {
      return { ...this.pickerOptions };
    },
  },
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    updateDisabledEndDate() {
      this.pickerOptionsComparate.disabledDate = (time) => {
        const currentDate = this.rangeDate[0]
          ? new Date(this.rangeDate[0])
          : new Date();
        currentDate.setHours(0, 0, 0, 0);

        return time.getTime() >= currentDate.getTime();
      };
    },

    handledOnChecked(checked) {
      this.$set(this.model, 'comparate', checked);
      this.getPreviousYearWeek;
      this.updateDisabledEndDate();
    },

    verifyIsset(data) {
      return isset(data);
    },

    getBusinessByAssociation() {
      let resp = [];
      if (this.model.association_ids.length > 0) {
        this.businesses.forEach((business) => {
          if (business.association) {
            const result = business.association.find((item) =>
              this.model.association_ids.includes(item)
            );
            if (result) resp.push(business);
          }
        });
      } else resp = this.businesses;

      return resp.length > 0 ? this.concatAll(resp) : [];
    },

    getCropsByBusinesses() {
      let resp = [];
      let businessesIds =
        this.model.businesses_ids.length > 0
          ? this.model.businesses_ids
          : this.getBusinessByAssociation().map((business) => business.id);

      businessesIds = businessesIds.concat(
        this.model.association_ids.length > 0
          ? this.model.association_ids
          : this.associations.map((business) => business.id)
      );

      businessesIds = [...new Set(businessesIds)];
      if (businessesIds.length === 1 && Number(businessesIds[0]) === 0)
        resp = this.crops ? this.crops : [];
      else if (businessesIds.length > 0) {
        this.crops.forEach((crop) => {
          if (crop.businesses) {
            const result = crop.businesses.find((item) =>
              businessesIds.includes(item.id)
            );
            if (result) resp.push(crop);
          }
        });
      } else resp = this.crops;

      return resp.length > 0 ? this.concatAll(resp) : [];
    },

    getLotbyFarm() {
      let resp = [];
      const farmIds = Array.isArray(this.model.farm_ids)
        ? this.model.farm_ids
        : [this.model.farm_ids];

      this.farms.forEach((element) => {
        if (farmIds.includes(element.id)) {
          element.lots.forEach((item) => {
            resp.push({
              id: item.id,
              name: `Finca ${element.name} - ${item.name}`,
            });
          });
        }
      });

      return this.concatAll(resp);
    },

    getRibbons() {
      let resp = [];
      const businessesIds = this.fillBusiness();
      if (businessesIds.length === 1 && Number(businessesIds[0]) === 0)
        resp = this.ribbons ? this.ribbons : [];
      else if (businessesIds.length > 0) {
        this.ribbons.forEach((ribbon) => {
          if (ribbon.businesses) {
            const result = ribbon.businesses.find((item) =>
              businessesIds.includes(item.id)
            );
            if (result) resp.push(ribbon);
          }
        });
      } else resp = this.ribbons;

      if (this.model.calendar_sel && this.model.calendar_sel.length > 0) {
        const respByRibbon = [...resp];
        resp = respByRibbon.filter((ribbon) => {
          return (
            ribbon.calendar &&
            this.model.calendar_sel.includes(ribbon.calendar_id)
          );
        });
      }

      return resp.length > 0 ? this.concatAll(resp, 'color_name') : [];
    },

    fillBusiness() {
      let businessesIds =
        this.model.businesses_ids.length > 0
          ? this.model.businesses_ids
          : this.getBusinessByAssociation().map((business) => business.id);

      businessesIds = businessesIds.concat(
        this.model.association_ids.length > 0
          ? this.model.association_ids
          : this.associations.map((business) => business.id)
      );

      businessesIds = [...new Set(businessesIds)];
      return businessesIds;
    },

    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
      switch (data.name) {
        case 'bySel':
          this.$set(this.model, 'week_sel_end', null);
          this.$set(this.model, 'week_sel_init', null);
          this.$set(this.model, 'year_sel_end', null);
          this.$set(this.model, 'year_sel_init', null);

          if (this.model.comparate) {
            this.$set(this.model, 'comp_week_sel_end', null);
            this.$set(this.model, 'comp_week_sel_init', null);
            this.$set(this.model, 'comp_year_sel_end', null);
            this.$set(this.model, 'comp_year_sel_init', null);
          }

          if (data.selects === '') this.model.bySel = null;
          else this.changeByInterval();
          break;

        case 'association_ids':
          this.$set(this.model, 'businesses_ids', []);
          this.$set(this.model, 'farm_ids', []);
          this.$set(this.model, 'lot_ids', []);
          this.$set(this.model, 'ribbons_id', []);
          this.$set(this.model, 'crops_ids', []);
          this.$set(this.model, 'users_ids', []);
          this.filterUsersByBusinesses();

          this.$set(this.model, 'workers_ids', []);
          this.filterWorkersByfarms();
          break;

        case 'businesses_ids':
        case 'subzone_ids':
        case 'croptypes_ids':
        case 'crops_ids':
          this.$set(this.model, 'farm_ids', []);
          this.$set(this.model, 'lot_ids', []);
          this.$set(this.model, 'users_ids', []);

          if (data.name === 'businesses_ids') {
            this.$set(this.model, 'crops_ids', []);
            this.$set(this.model, 'ribbons_id', []);
            this.filterUsersByBusinesses();
          }

          break;

        case 'farm_ids':
          this.$set(this.model, 'lot_ids', []);
          this.showCalendar(this.model, this.farms, this.model.farm_ids);
          this.$set(this.model, 'workers_ids', []);
          this.filterWorkersByfarms();

          try {
            this.$emit('onFarmChange', this.model);
          } catch (error) {
            //
          }

          break;

        case 'zone_ids':
          this.$set(this.model, 'farm_ids', []);
          this.$set(this.model, 'lot_ids', []);

          break;

        default:
          break;
      }
      this.$emit('onChangeFilters', this.model);
    },

    changeByInterval() {
      const intervals = Object.values(this.optionsInterval);
      intervals.forEach((element) => {
        if (element.model == this.model.bySel) {
          this.typedatepicket = element.value;
        }
      });
    },

    isYearSelRequired() {
      return this.interval == 'Semana';
    },

    isWeekSekRequired() {
      return this.interval == 'Semana';
    },
  },

  created() {
    this.showHideLoading(true);
    const axiosRequests = this.getEndPoints();

    Promise.all(axiosRequests)
      .then((response) => {
        this.runData(response);
        this.showHideLoading();
      })
      .catch((error) => {
        SweetAlert.warning(error.response.data.message);
      });
  },

  mounted() {
    const current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay() - 10)),
      new Date(),
    ];

    const initDate = new Date(
      new Date().setDate(new Date().getDate() - new Date().getDay() - 7)
    );
    const endDate = new Date(
      new Date().setDate(new Date().getDate() - new Date().getDay() - 1)
    );
    this.rangeDateComparate = [initDate, endDate];
  },
};
</script>
